import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["aria-label", "title"]

import { computed } from 'vue'
import { useTitle } from '@/composables/ui/useTitle'
import { useColorScheme } from '@/composables/ui/useColorScheme'
import { useThemeStore } from '@/stores/theme'
import { useAuthStore } from '@/stores/auth'
import BaseToast from '@/components/ui/BaseToast.vue'
import { Sun, Moon } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Diasporiques ABA Solutions LLC')
useTitle(appTitle.value, { suffix: false })

useColorScheme()

const themeStore = useThemeStore()
const authStore = useAuthStore()
const isDarkMode = computed(() => themeStore.isDarkMode)
const isAuthenticated = computed(() => authStore.isAuthenticated)

function toggleTheme() {
  themeStore.toggleTheme()
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(BaseToast),
    (!isAuthenticated.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "theme-toggle-btn",
          onClick: toggleTheme,
          "aria-label": isDarkMode.value ? 'Switch to light mode' : 'Switch to dark mode',
          title: isDarkMode.value ? 'Switch to light mode' : 'Switch to dark mode'
        }, [
          (isDarkMode.value)
            ? (_openBlock(), _createBlock(_unref(Sun), {
                key: 0,
                class: "h-5 w-5"
              }))
            : (_openBlock(), _createBlock(_unref(Moon), {
                key: 1,
                class: "h-5 w-5"
              }))
        ], 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})